export default __webpack_public_path__ + "static/media/Trapper's Sword.dc047c47.jpg";